import posthog from 'posthog-js'

const DEFAULT_TOKEN = 'phc_ykQpBqAijW5tJ72zgcpLc8DGiyHgRVg2mrc6NiFWATFD'
const TOKEN =
  import.meta.env.VITE_POSTHOG_PROJECT_TOKEN ||
  import.meta.env.VITE_POSTHOG_KEY ||
  DEFAULT_TOKEN
const HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com'
const ANALYTICS_HOSTS = new Set([
  'bloomagrows.com',
  'www.bloomagrows.com',
  'wtf.bloomagrows.com',
])

export type LandingPage = 'grocery' | 'join' | 'wtf'

function isProductionAnalyticsHost() {
  if (typeof window === 'undefined') return false
  return ANALYTICS_HOSTS.has(window.location.hostname.toLowerCase())
}

export function initLandingPosthog(landing: LandingPage) {
  if (!isProductionAnalyticsHost()) return false
  if (!TOKEN) return false

  if (!posthog.__loaded) {
    posthog.init(TOKEN, {
      api_host: HOST,
      defaults: '2026-05-30',
      capture_pageview: false,
      person_profiles: 'identified_only',
    })
  }

  posthog.register({
    landing_page: landing,
    landing:
      landing === 'grocery' ? '/grocery' : landing === 'wtf' ? '/wtf' : '/join',
  })
  posthog.capture('$pageview', { landing_page: landing })
  return true
}

export function captureLanding(
  event: string,
  properties?: Record<string, unknown>,
) {
  if (!isProductionAnalyticsHost() || !posthog.__loaded) return
  posthog.capture(event, properties)
}

export function identifyLandingLead(email: string) {
  const id = email.trim().toLowerCase()
  if (!id || !isProductionAnalyticsHost() || !posthog.__loaded) return
  posthog.identify(id, { email: id })
}
